// material
import {
  ArrowCircleLeft,
  ArrowDropUp,
  ArrowDropUpOutlined,
  ArrowRight,
  ArrowRightAlt,
  AutoStories,
  Book,
  CallMade,
  CallMadeOutlined,
  CallReceivedOutlined,
  ContentCopy,
  CurrencyRupeeSharp,
  DeliveryDining,
  Facebook,
  FacebookRounded,
  FacebookTwoTone,
  LeaderboardSharp,
  LightbulbCircle,
  Link,
  PersonOffSharp,
  PersonSharp,
  Task,
  TaskAltSharp
} from "@mui/icons-material";

import {
  Box,
  Card,
  Grid,
  Container,
  Typography,
  CardHeader,
  Tooltip,
  IconButton,
  Icon,
  Paper,
  Divider
} from "@mui/material";
import { useEffect, useState } from "react";
import { notification } from "src/utils/messages";

// components
import Page from "../components/Page";
import {
  AppTasks,
  AppNewUsers,
  AppBugReports,
  AppItemOrders,
  AppNewsUpdate,
  AppWeeklySales,
  AppOrderTimeline,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppTrafficBySite,
  AppCurrentSubject,
  AppConversionRates
} from "../components/_dashboard/app";
import { alpha, styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { Icons } from "react-toastify";
import { Routes } from "src/constant/api_url";
import { fetchPrimeDashboardCounter } from "src/utils/common";
// import Paper from "src/theme/overrides/Paper";

// ----------------------------------------------------------------------

export default function DashboardApp() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  let navigate = useNavigate();
  const [formLink, setFormLink] = useState({});
  const RootStyle = styled(Card)(({ theme }) => ({
    boxShadow: "none",
    textAlign: "center",
    padding: theme.spacing(5, 0),
    color: theme.palette.info.darker,
    backgroundColor: theme.palette.info.lighter
  }));

  const IconWrapperStyle = styled("div")(({ theme }) => ({
    margin: "auto",
    display: "flex",
    borderRadius: "50%",
    alignItems: "center",
    width: theme.spacing(8),
    height: theme.spacing(8),
    justifyContent: "center",
    marginBottom: theme.spacing(3),
    color: theme.palette.info.dark,
    backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.info.dark, 0)} 0%, ${alpha(
      theme.palette.info.dark,
      0.24
    )} 100%)`
  }));

  const [dashboardCount, setDashboardCount] = useState({});

  useEffect(async () => {
    setDashboardCount(await fetchPrimeDashboardCounter(loginUser?.u_id, loginUser?.u_type));

    if (loginUser?.u_type == 3) {
      // setFormLink(window.location.origin + "/primeinquiry-form");
      setFormLink({
        primeInquiry: window.location.origin + "/primeinquiry-form",
        primeLeadinquiry: window.location.origin + "/prime-location-inquiry-form"
      });
    }
  }, []);

  const openInNewTab = async (link) => {
    navigator.clipboard.writeText(link);
    let notify = notification({
      type: "info",
      message: "Copy to clipboard",
      position: "top"
    });
    await notify();
  };
  return (
    <Page title="Local Vocal Business Group">
      <Container maxWidth="xl">
        <Box sx={{ pb: 0 }}>
          <Typography variant="h4">Hi, Welcome {loginUser?.name}</Typography>
        </Box>
        {/* <CardHeader title="Form Link" /> */}
        <Grid container spacing={12}>
          <Grid item xs={12} sm={12} md={12}>
            <Box sx={{ py: 3 }}>
              <Card>
                <CardHeader
                  title={
                    <>
                      <span>Inquiry Form Link</span>
                    </>
                  }
                />

                <Box sx={{ px: 3, pt: 1 }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span>
                      <Link
                        color="dark"
                        className="RotateIcon"
                        style={{ transform: "rotate(140deg)" }}
                      />
                    </span>

                    <span style={{ marginLeft: "5px" }}>{formLink?.primeInquiry}</span>

                    <span
                      onClick={() => openInNewTab(formLink?.primeInquiry)}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Tooltip title="Click to Copy Link">
                        <IconButton size="small">
                          <ContentCopy color="dark" />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </div>
                </Box>
              </Card>
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={12}>
          <Grid item xs={12} sm={12} md={12}>
            <Box>
              <Card>
                <CardHeader
                  title={
                    <>
                      <span>Inquiry With Location Form Link</span>
                    </>
                  }
                />

                <Box sx={{ px: 3, pb: 1 }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span>
                      <Link
                        color="dark"
                        className="RotateIcon"
                        style={{ transform: "rotate(140deg)" }}
                      />
                    </span>

                    <span style={{ marginLeft: "5px" }}>{formLink?.primeLeadinquiry}</span>

                    <span
                      onClick={() => openInNewTab(formLink?.primeLeadinquiry)}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Tooltip title="Click to Copy Link">
                        <IconButton size="small">
                          <ContentCopy color="dark" />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </div>
                </Box>
              </Card>
            </Box>
          </Grid>
        </Grid>

        {/* Counter */}
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ py: 3 }}>
              <Card
                className="box-hover"
                onClick={() => navigate("/lead")}
                style={{ cursor: "pointer" }}
              >
                <Box sx={{ px: 3, py: 4 }} style={{ textAlign: "center" }}>
                  <IconWrapperStyle>
                    <LeaderboardSharp
                      width={24}
                      height={24}
                      color="warning"
                      className="tada-amin"
                    />
                  </IconWrapperStyle>
                  <Typography variant="h3">{dashboardCount?.lead_count}</Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ opacity: 1, color: "#707070", fontSize: "17px" }}
                  >
                    Total Lead
                  </Typography>
                </Box>
              </Card>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ py: 3 }}>
              <Card
                className="box-hover"
                onClick={() => navigate("/lead")}
                style={{ cursor: "pointer" }}
              >
                <Box sx={{ px: 3, py: 4 }} style={{ textAlign: "center" }}>
                  <IconWrapperStyle>
                    <LeaderboardSharp
                      width={24}
                      height={24}
                      color="success"
                      className="tada-amin"
                    />
                  </IconWrapperStyle>
                  <Typography variant="h3">{dashboardCount?.today_waiting_lead_counter}</Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ opacity: 1, color: "#707070", fontSize: "17px" }}
                  >
                    Today's Waiting For Verify
                  </Typography>
                </Box>
              </Card>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ py: 3 }}>
              <Card
                className="box-hover"
                onClick={() => navigate("/lead")}
                style={{ cursor: "pointer" }}
              >
                <Box sx={{ px: 3, py: 4 }} style={{ textAlign: "center" }}>
                  <IconWrapperStyle>
                    <LeaderboardSharp
                      width={24}
                      height={24}
                      color="success"
                      className="tada-amin"
                    />
                  </IconWrapperStyle>
                  <Typography variant="h3">{dashboardCount?.today_confirm_lead_counter}</Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ opacity: 1, color: "#707070", fontSize: "17px" }}
                  >
                    Today's Confirm Lead
                  </Typography>
                </Box>
              </Card>
            </Box>
          </Grid>
          {loginUser?.u_type == 3 && (
            <>
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{ py: 3 }}>
                  <Card
                    className="box-hover"
                    onClick={() => navigate("/welcome-kit")}
                    style={{ cursor: "pointer" }}
                  >
                    <Box sx={{ px: 3, py: 4 }} style={{ textAlign: "center" }}>
                      <IconWrapperStyle>
                        <DeliveryDining width={24} height={24} color="info" className="tada-amin" />
                      </IconWrapperStyle>
                      <Typography variant="h3">{dashboardCount?.courier_pending_count}</Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{ opacity: 1, color: "#707070", fontSize: "17px" }}
                      >
                        Courier Pending
                      </Typography>
                    </Box>
                  </Card>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{ py: 3 }}>
                  <Card
                    className="box-hover"
                    onClick={() => navigate("/member")}
                    style={{ cursor: "pointer" }}
                  >
                    <Box sx={{ px: 3, py: 4 }} style={{ textAlign: "center" }}>
                      <IconWrapperStyle>
                        <PersonSharp width={24} height={24} color="error" className="tada-amin" />
                      </IconWrapperStyle>
                      <Typography variant="h3">{dashboardCount?.member_count}</Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{ opacity: 1, color: "#707070", fontSize: "17px" }}
                      >
                        Total Members
                      </Typography>
                    </Box>
                  </Card>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{ py: 3 }}>
                  <Card
                    className="box-hover"
                    onClick={() => navigate("/lvb-suggestion")}
                    style={{ cursor: "pointer" }}
                  >
                    <Box sx={{ px: 3, py: 4 }} style={{ textAlign: "center" }}>
                      {/* Icon */}
                      <IconWrapperStyle>
                        <LightbulbCircle
                          width={24}
                          height={24}
                          color="primary"
                          className="tada-amin"
                        />
                      </IconWrapperStyle>

                      {/* Today's Suggestions */}
                      <Typography variant="h4" sx={{ mt: 2 }}>
                        {dashboardCount?.today_suggestion}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{ color: "#707070", fontSize: "15px", mb: 2 }}
                      >
                        Today's Suggestions
                      </Typography>

                      {/* Divider or spacing */}
                      <Divider sx={{ my: 1 }} />

                      {/* Pending Suggestions */}
                      <Typography variant="h4" sx={{ mt: 2 }}>
                        {dashboardCount?.pedning_suggestion}
                      </Typography>
                      <Typography variant="subtitle2" sx={{ color: "#707070", fontSize: "15px" }}>
                        Pending Suggestions
                      </Typography>
                    </Box>
                  </Card>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{ py: 3 }}>
                  <Card
                    className="box-hover"
                    onClick={() => navigate("/cancel-membership-request")}
                    style={{ cursor: "pointer" }}
                  >
                    <Box sx={{ px: 3, py: 4 }} style={{ textAlign: "center" }}>
                      <IconWrapperStyle>
                        <PersonOffSharp
                          width={24}
                          height={24}
                          color="error"
                          className="tada-amin"
                        />
                      </IconWrapperStyle>
                      <Typography variant="h3">{dashboardCount?.cancel_member_count}</Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{ opacity: 1, color: "#707070", fontSize: "17px" }}
                      >
                        Total Cancel Members Request
                      </Typography>
                    </Box>
                  </Card>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{ py: 3 }}>
                  <Card
                    className="box-hover"
                    onClick={() => {
                      const today = new Date().toISOString().split("T")[0];
                      navigate("/referral-report", {
                        state: { w_status: 1, from_date: today, to_date: today }
                      });
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <Box sx={{ px: 3, py: 4 }} style={{ textAlign: "center" }}>
                      <IconWrapperStyle>
                        <CallReceivedOutlined
                          width={24}
                          height={24}
                          color="warning"
                          className="tada-amin"
                        />
                      </IconWrapperStyle>

                      <Typography variant="h4" sx={{ mt: 2 }}>
                        {dashboardCount?.total_withdraw_request_count}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{ color: "#707070", fontSize: "15px", mb: 2 }}
                      >
                        Total Withdraw Requests
                      </Typography>

                      <Divider sx={{ my: 1 }} />

                      <Typography variant="h4" sx={{ mt: 2 }}>
                        {dashboardCount?.pending_withdraw_request_count}
                      </Typography>
                      <Typography variant="subtitle2" sx={{ color: "#707070", fontSize: "15px" }}>
                        Pending Withdraw Requests
                      </Typography>
                    </Box>
                  </Card>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{ py: 3 }}>
                  <Card
                    className="box-hover"
                    onClick={() => navigate("/referral-withdrawal-requests")}
                    style={{ cursor: "pointer" }}
                  >
                    <Box sx={{ px: 3, py: 4 }} style={{ textAlign: "center" }}>
                      <IconWrapperStyle>
                        <CurrencyRupeeSharp
                          width={24}
                          height={24}
                          color="success"
                          className="tada-amin"
                        />
                      </IconWrapperStyle>

                      <Typography variant="h4" sx={{ mt: 2 }}>
                        ₹
                        {Number(
                          dashboardCount?.total_withdraw_request_amount || 0
                        ).toLocaleString("en-IN")}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{ color: "#707070", fontSize: "15px", mb: 2 }}
                      >
                        Total Withdraw Amount
                      </Typography>

                      <Divider sx={{ my: 1 }} />

                      <Typography variant="h4" sx={{ mt: 2 }}>
                        ₹
                        {Number(
                          dashboardCount?.pending_withdraw_request_amount || 0
                        ).toLocaleString("en-IN")}
                      </Typography>
                      <Typography variant="subtitle2" sx={{ color: "#707070", fontSize: "15px" }}>
                        Pending Withdraw Amount
                      </Typography>
                    </Box>
                  </Card>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{ py: 3 }}>
                  <Card
                    className="box-hover"
                    onClick={() => {
                      const today = new Date().toISOString().split("T")[0];
                      navigate("/referral-report", {
                        state: { w_status: 0, from_date: today, to_date: today }
                      });
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <Box sx={{ px: 3, py: 4 }} style={{ textAlign: "center" }}>
                      <IconWrapperStyle>
                        <CallReceivedOutlined
                          width={24}
                          height={24}
                          color="warning"
                          className="tada-amin"
                        />
                      </IconWrapperStyle>

                      <Typography variant="h4" sx={{ mt: 2 }}>
                        {dashboardCount?.successful_refer_count}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{ color: "#707070", fontSize: "15px", mb: 2 }}
                      >
                        Total Successful Refer Count
                      </Typography>

                      <Divider sx={{ my: 1 }} />

                      <Typography variant="h4" sx={{ mt: 2 }}>
                        {dashboardCount?.successful_refer_amount}
                      </Typography>
                      <Typography variant="subtitle2" sx={{ color: "#707070", fontSize: "15px" }}>
                        Total Successful Refer Amount
                      </Typography>
                    </Box>
                  </Card>
                </Box>
              </Grid>
            </>
          )}
        </Grid>
        {/* End Counter */}
      </Container>
    </Page>
  );
}
